import { Box } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export const PageBackLink = ({ pageBack }) => (
  <Box w="100%" textAlign="left" p="4">
    <Link onClick={(e) => pageBack(e)}>{'< 前のページに戻る'}</Link>
  </Box>
)
